import React, {CSSProperties} from 'react';
import styles from './DefaultPage.module.scss';
import clsx from 'clsx';

type DefaultPageProps = React.PropsWithChildren<{
  style?: CSSProperties;
  className?: string;
}>;

const DefaultPage = (props: DefaultPageProps, ref: React.Ref<HTMLElement>) => {
  const {style, className, children} = props;
  const actualStyle = style ?? {};
  const actualClassName = className ?? '';
  return (
    <div className={clsx(styles.sectionWrapper, 'defaultPage', actualClassName)} style={actualStyle}>
      <section className={styles.section} ref={ref}>
        {children}
      </section>
    </div>
  );
};

export default React.forwardRef<HTMLElement, DefaultPageProps>(DefaultPage);
